module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "dog-profile",
      "classes": "cute-dog-profile-photo",
      "transition": "scale",
      "height": 260,
      "width": 260
    },
    on: {
      "opened": _vm.opened
    }
  }, [_c('div', {
    staticClass: "ct-top-right",
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_vm._v("\n    HIDE THE DOGGY\n  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/cute_dog.gif"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ab1920"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DogProfileModal.vue
// module id = 34
// module chunks = 0